import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'ngx-slide-unlock',
  template: `
    <input type="range" [attr.class]="theme"  value="0" max="100" [(ngModel)]="value" (ngModelChange)="valida($event)">
  `,
  styleUrls: ['./ngx-slide-unlock.component.css']
})
export class NgxSlideUnlockComponent implements OnInit {
  value: number = 0
  theme = "light slideToUnlockEN"
  timeLeft: number = 1;
  interval;
  @Output() status: EventEmitter<boolean> = new EventEmitter();
  @Input() lang = 'es'
  @Input() color = 'light'

  constructor() { }

  async ngOnInit() {
    this.lang = await this.lang.toLowerCase()
    this.theme = await `${this.color} ${this.lang == 'es' ? 'slideToUnlockES' : 'slideToUnlockEN'}`
  }

  async valida(val) {
    await this.pauseTimer()
    this.startTimer(this.value, 0)
  }

  startTimer(text, delay) {
    this.timeLeft = delay
    this.interval = setInterval(async () => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.pauseTimer();
        if (this.value >= 97) {
          this.status.emit(true)
        } else {
          this.status.emit(false)
          this.value = 0
        }
      }
    }, 150)
  }

  pauseTimer() {
    clearInterval(this.interval);
  }

}
